import React from "react";

interface ILoadingComponentProps {
fullPage? : boolean,
}

const LoadingComponent = (props: ILoadingComponentProps) => {
  return (
    <div
    id="elements-loading"
    style={props.fullPage ? {      
      top: "50%",
        left: "50%",
        width: "30em",
        height: "18em",
        transform: "translate(-50%, -50%)",
        position: "fixed",
    } : 
    {
      position: "relative",
      top: "50%",
      width: "50%",
      zIndex: 10000,
      
    }}
  >
    <div
      className="threeBallsFalling"
      style={{ position: "relative" }}
    ></div>
  </div>
  );
};

export default LoadingComponent;
